const formValidation = (text: string, rating: number) => {
  const errors = {
    rating: false,
    text: false,
  };
  if (rating < 1 || rating > 5) {
    errors.rating = true;
  }
  if (text.length && (text.length < 50 || text.length > 5000)) {
    errors.text = true;
  }
  return errors;
};

export default formValidation;
